import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import TagsInput from 'react-tagsinput';
import locales from 'locales';

import '../styles/ReactTagsinput.css';
import '../styles/NodeEditor.css';
import uploadFile from 'utils/FileService';
import CircularProgress from '@material-ui/core/CircularProgress';
import projectConfig from 'config';
import Translate, {t} from 'components/Translate';
import TranslateProperty from 'components/TranslateProperty';
import {getFileNameFromLink} from '../util';
import {DeleteIcon} from '../assets/svgIcons';
import config from '../config';
import {getFileType} from '../../../../../utils/FileService';
import {editButtonIndex} from "../services/api";

class NodeEditor extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            touched: false,
            dragIsActive: false,
            id: null,
            name: '',
            message: '',
            messages: [],
            buttons: [],
            tags: [],
            botAttachments: [],
            terminalMessage: false,
            chatWithOperator: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.node.id !== state.id) {
            return Object.assign({}, state, {
                ...props.node,
                messages: props.node ? props.node.message.split("/n") : []
            }, {
                touched: false,
            });
        }
    }

    configButtons() {
        let {buttons} = this.state
        buttons.map(button => {
            button.showLinkInput = button.text.includes("||")
            if (button.showLinkInput) {
                button.link = button.text.split("||")[1]
                button.shortText = button.text.split("||")[0]
            } else {
                button.link = button.text.split("||")[1]
                button.shortText = button.text
            }

            button.text = button.showLinkInput ? button.shortText + "||" + button.link : button.text
        })

        this.setState({
            touched: true,
            buttons,
        });
    }

    componentDidMount() {
        this.configButtons();

    }

    // componentDidUpdate(prevProps, prevState) {
    //     this.configButtons();
    // }

    updateTextValue = name => (event) => {
        if (name === "message") {
            this.setState({
                touched: true,
                message: event.target.value,
                messages: event.target.value.split("/n")
            });
        } else {
            this.setState({
                touched: true,
                [name]: event.target.value,
            });
        }

    };

    toggleState = name => () => {
        this.setState({
            touched: true,
            [name]: !this.state[name],
        });
    };

    removeButton = buttonId => () => {
        const buttons = [...this.state.buttons];
        const removeButtonIndex = buttons.findIndex(button => button.id === buttonId);
        if (removeButtonIndex !== -1) {
            buttons.splice(removeButtonIndex, 1);
        }

        this.setState({
            touched: true,
            buttons,
        });
    };

    addButton = () => {
        const {addNotification, user} = this.props;
        let {buttons} = this.state;

        if (buttons.length >= config.nodeData.maxButtons) {
            addNotification('maxNumberOfButtonsIs', projectConfig.notificationLevels.error);
            return;
        }

        let minIndex = -1;
        buttons.forEach((button) => {
            if (button.id <= minIndex) {
                minIndex -= 1;
            }
        });

        const newButton = {
            id: minIndex,
            text: `${locales[user.language].newButton}`,
            shortText: `${locales[user.language].newButton}`,
        };

        buttons = [...buttons, newButton];
        this.setState({
            touched: true,
            buttons,
        });
    };

    toggleLinkInputVisibility = buttonId => () => {
        let {buttons} = this.state;
        buttons = buttons.map((button) => {
            if (button.id === buttonId) {
                button.showLinkInput = !button.showLinkInput;
            }
            return button;
        });

        this.setState({
            touched: true,
            buttons,
        });
    };

    addBotMessage = () => {
        const oldMessagesList = this.state.messages;
        oldMessagesList.push("");
        this.setState({
            messages: oldMessagesList,
            message: oldMessagesList.join(" /n ")
        })
    }

    editBotMessage = (index) => (event) => {
        const oldMessagesList = this.state.messages;
        oldMessagesList.splice(index, 1, event.target.value);
        this.setState({
            messages: oldMessagesList,
            message: oldMessagesList.join(" /n ")
        })
    }

    removeBotMessage = (index) => () => {
        const oldMessagesList = this.state.messages;
        oldMessagesList.splice(index, 1);
        this.setState({
            messages: oldMessagesList,
            message: oldMessagesList.join(" /n ")
        })
    }

    handleNodeTagsChange = (tags) => {
        this.setState({
            touched: true,
            tags,
        });
    };

    addAttachment = (attachmentData) => {
        const botAttachments = this.state.botAttachments ? this.state.botAttachments : [];
        this.setState({
            touched: true,
            botAttachments: [...botAttachments, attachmentData],
        });
    };

    removeAttachment = link => () => {
        const botAttachments = [...this.state.botAttachments];
        const removeAttachmentIndex = botAttachments.findIndex(attachmentData => attachmentData.link === link);
        if (removeAttachmentIndex !== -1) {
            botAttachments.splice(removeAttachmentIndex, 1);
        }

        this.setState({
            touched: true,
            botAttachments,
        });
    };

    uploadFile = (files) => {
        const {readonly} = this.props;
        if (readonly) {
            return;
        }

        this.setState({
            dragIsActive: false,
        });

        const data = new FormData();
        data.append('file', files[0]);
        uploadFile(data)
            .then((link) => {
                const attachmentData = {
                    link,
                    type: getFileType(files[0].type),
                };
                this.addAttachment(attachmentData);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    onDragEnter = () => {
        const {readonly} = this.props;
        if (readonly) {
            return;
        }
        this.setState({
            dragIsActive: true,
        });
    };

    onDragLeave = () => {
        this.setState({
            dragIsActive: false,
        });
    };

    getNodeData = () => {
        const buttons = this.state.buttons.map((button) => {
            if (button.id > 0) {
                button.text = button.showLinkInput && button.link ? button.shortText + "||" + button.link : button.shortText
                return button;
            }
            return {
                text: button.showLinkInput && button.link ? button.shortText + "||" + button.link : button.shortText,
            };
        });

        const {
            id, name, message, terminalMessage, botAttachments, tags, chatWithOperator,
        } = this.state;
        return {
            id,
            name,
            message,
            buttons,
            terminalMessage,
            tags,
            botAttachments,
            chatWithOperator,
        };
    };

    updateButtonText = (buttonId) => (event) => {
        let {buttons} = this.state;
        buttons = buttons.map((button) => {
            if (button.id === buttonId) {
                button.shortText = event.target.value;
            }
            return button;
        });

        this.setState({
            touched: true,
            buttons,
        });
    };

    handleLinkChange = (buttonId) => (event) => {
        let {buttons} = this.state;
        buttons = buttons.map((button) => {
            if (button.id === buttonId) {
                button.link = event.target.value;
            }
            return button;
        });

        this.setState({
            touched: true,
            buttons,
        });
    };

    moveButtonUp = (index) => {
        if (index <= 0) return;

        const updatedButtons = [...this.state.buttons];
        [updatedButtons[index - 1], updatedButtons[index]] = [updatedButtons[index], updatedButtons[index - 1]];

        updatedButtons.forEach((btn, i) => btn.index = i);

        this.setState({buttons: updatedButtons});

        const messageId = this.state.id;
        const buttonId = updatedButtons[index].id;
        const newIndex = updatedButtons[index - 1].index;

        editButtonIndex(messageId, buttonId, newIndex)
            .then(response => {
            })
            .catch(error => {
            });
    };

    moveButtonDown = (index) => {
        if (index >= this.state.buttons.length - 1) return;

        const updatedButtons = [...this.state.buttons];
        [updatedButtons[index], updatedButtons[index + 1]] = [updatedButtons[index + 1], updatedButtons[index]];

        updatedButtons.forEach((btn, i) => btn.index = i);

        this.setState({buttons: updatedButtons});

        const messageId = this.state.id;
        const buttonId = updatedButtons[index].id;
        const newIndex = updatedButtons[index + 1].index;

        editButtonIndex(messageId, buttonId, newIndex)
            .then(response => {
            })
            .catch(error => {
            });
    };


    render() {
        const {
            name,
            message,
            terminalMessage,
            buttons,
            botAttachments,
            tags,
            chatWithOperator,
            touched,
            messages,
        } = this.state;
        const {
            editingNode, deletingNode, node, user,
        } = this.props;
        const editing = editingNode || deletingNode;
        const addTagText = `${locales[user.language].addTag}`;


        const buttonsView = buttons.map((button, idx) => {
            return (
                <li className="node-button-wrapper" key={button.id}>
                    <div className="node-button">

                        <div style={{marginRight: '5px', display: 'flex', alignItems: 'center'}}>
                            <button
                                onClick={() => this.moveButtonUp(idx)}
                                disabled={idx === 0}
                                title="Move Up"
                                style={{marginLeft: '5px'}}
                            >
                                ↑
                            </button>
                            <button
                                onClick={() => this.moveButtonDown(idx)}
                                disabled={idx === buttons.length - 1}
                                title="Move Down"
                                style={{marginLeft: '2px'}}
                            >
                                ↓
                            </button>
                        </div>

                        <input
                            type="text"
                            className="node-button-text controller"
                            value={button.shortText}
                            maxLength={100}
                            onChange={this.updateButtonText(button.id)}
                        />
                        <div className="edge-delete delete-icon-wrapper controller"
                             onClick={this.removeButton(button.id)}>
                            <DeleteIcon/>
                        </div>
                        <input
                            style={{marginBottom: '3px'}}
                            type="checkbox"
                            checked={button.showLinkInput}
                            onChange={this.toggleLinkInputVisibility(button.id)}
                            title={t({text: "isLink", user})}
                        />
                    </div>
                    <div className="link-input-wrapper">
                        {button.showLinkInput && (
                            <div>
                                <input
                                    style={{width: '91%', marginBottom: '20px'}}
                                    type="text"
                                    className="node-button-text controller"
                                    placeholder={t({text: "link", user})}
                                    value={button.link}
                                    onChange={this.handleLinkChange(button.id)}
                                />
                            </div>
                        )}
                    </div>
                </li>
            );
        });


        const messagesListView = messages.map((message, index) => (
            <li className="node-button-wrapper" key={`${index}`}>
                <div className="node-button">
                    <input
                        type="text"
                        className="node-button-text controller"
                        value={message}
                        onChange={this.editBotMessage(index)}
                    />
                    <div className="edge-delete delete-icon-wrapper controller" onClick={this.removeBotMessage(index)}>
                        <DeleteIcon/>
                    </div>
                </div>
            </li>
        ))

        const handleChildClick = (event) => {
            event.stopPropagation();
        };

        return (
            <div onClick={
                handleChildClick
            } className={`graph-vertex-controller controller-view${editing ? 'disabled-container' : ''}`}>
                {editing && <div className="container-overlay"/>}
                <Dropzone
                    disableClick
                    className="ignore"
                    multiple={false}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.uploadFile}
                    style={{position: 'relative'}}
                >
                    {this.state.dragIsActive && (
                        <div className="drag-overlay">
                            Upload Files...
                        </div>
                    )}
                    <header>
                        <ul className="flex-list">
                            <li className="vertex-name">
                                <input type="text" className="controller" value={name || ''}
                                       onChange={this.updateTextValue('name')}/>
                            </li>
                            <li className="node-delete ">
                                <button className="controller" onClick={() => {
                                    this.props.deleteNode(node);
                                }}>
                                    <Translate text="delete"/>
                                    {' '}
                                    {deletingNode && <CircularProgress size={10}/>}
                                </button>
                            </li>
                            <li className={touched ? 'node-save active' : 'node-save'}>
                                <button
                                    className="controller"
                                    onClick={() => {
                                        this.props.editNode(this.getNodeData());
                                    }}
                                >
                                    <Translate text="save"/>
                                    {' '}
                                    {editingNode && <CircularProgress size={10}/>}
                                </button>
                            </li>
                        </ul>
                    </header>
                    <section>
                        <div className="control-section border-bottom">
                            <h2 className="heading">
                                <Translate text="pleaseFillMessage"/>
                            </h2>
                            <textarea className="vertex-text controller" value={message}
                                      onChange={this.updateTextValue('message')}/>
                            <ul className="edges-list list">
                                {messagesListView}
                            </ul>
                            <div className="add-button-wrapper">
                                <button className="add-button button controller" onClick={this.addBotMessage}>
                                    <Translate text="addBotMessage"/>
                                </button>
                            </div>
                            <div className="tags-input controller">
                                <TagsInput addOnBlur={true} value={tags} onChange={this.handleNodeTagsChange}
                                           inputProps={{placeholder: addTagText}}/>
                            </div>
                            <div className="attach-file" style={{display: this.state.dragIsActive ? 'none' : 'block'}}>
                                <Dropzone className="ignore controller" multiple={false} onDrop={this.uploadFile}>
                                    <button className="attach-button button controller">
                                        <Translate text="attachFile"/>
                                    </button>
                                </Dropzone>
                                <ul className="list attachment-list">
                                    {botAttachments.map(attachment => (
                                        <li className={'attachment-file'} key={attachment.link}>
                                            <a className="attachment-link" href={attachment.link}>
                                                {getFileNameFromLink(attachment.link)}
                                            </a>
                                            <button className="attachment-delete button controller"
                                                    onClick={this.removeAttachment(attachment.link)}/>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="control-section border-bottom">
                            <h2 className="heading">
                                <Translate text="addButton"/>
                            </h2>
                            <ul className="edges-list list">
                                {buttonsView}
                            </ul>
                            <div className="add-button-wrapper">
                                <button className="add-button button controller" onClick={this.addButton}>
                                    <Translate text="add"/>
                                </button>
                            </div>
                        </div>
                        <div className="end-conversation-wrapper">
                            <div className="flex-list button-state-wrapper">
                                <TranslateProperty properties={[{key: 'value', value: 'endConversation'}]}>
                                    <input type="text" className="text controller" readOnly/>
                                </TranslateProperty>
                                <div className="switch-wrapper">
                                    <label className="switch controller"
                                           style={{display: this.state.dragIsActive ? 'none' : 'block'}}>
                                        <input
                                            type="checkbox"
                                            checked={terminalMessage}
                                            onChange={this.toggleState('terminalMessage')}
                                        />
                                        <span className="slider round"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="operator-questions-wrapper">
                            <div className="flex-list button-state-wrapper">
                                <TranslateProperty properties={[{key: 'value', value: 'chatWithOperator'}]}>
                                    <input type="text" className="text controller" readOnly/>
                                </TranslateProperty>
                                <div className="switch-wrapper">
                                    <label className="switch controller"
                                           style={{display: this.state.dragIsActive ? 'none' : 'block'}}>
                                        <input
                                            type="checkbox"
                                            checked={chatWithOperator}
                                            onChange={this.toggleState('chatWithOperator')}
                                        />
                                        <span className="slider round"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </section>
                </Dropzone>
            </div>);
    }
}

NodeEditor.propTypes = {
    node: PropTypes.object.isRequired,
    editingNode: PropTypes.bool.isRequired,
    deletingNode: PropTypes.bool.isRequired,
    readonly: PropTypes.bool.isRequired,
    editNode: PropTypes.func.isRequired,
    deleteNode: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default NodeEditor;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor.js